import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const RequireAuth = ({ parent, path, process, children }) => {
 const reduxUser = useSelector((state) => state.user);
  
  let user = reduxUser;
  if (!user || !user.usertype || !user.username) {
    try {
      const localStorageUser = JSON.parse(localStorage.getItem('userData'));
      if (localStorageUser && localStorageUser.username && localStorageUser.usertype) {
        user = localStorageUser;
      }
    } catch (error) {
      console.error('Error parsing localStorage userData:', error);
      return <Navigate to="/" />;
    }
  }

  if (user.usertype && user.usertype.toLowerCase() === 'superadmin') {
    return children;
  }

  const permissions = user.permissions?.[parent]?.[path] || {};
  
  let hasPermission = false;
  if (Array.isArray(process)) {
    hasPermission = process.some((p) => permissions[p] === true);
  } else {
    hasPermission = permissions[process] === true;
  }

  if (hasPermission) {
    return children;
  } else {
    return <Navigate to="/unauthorized" replace />;
  }
};

export default RequireAuth;
export const checkAuth = (parent, path, process) => {
  const user = JSON.parse(localStorage.getItem('userData'));
  if (user && user.usertype && user.usertype.toLowerCase() === 'admin') {
    return true;
  }
  const userState = user && user.username ? user : {};
  return userState.permissions?.[parent]?.[path]?.[process] || false;
};